"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableGoStraightIcon = PrintableGoStraightIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableGoStraightIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M12 0c-6.616 0-12 5.385-12 12.002s5.383 11.998 12 11.998 12-5.382 12-11.998-5.384-12.002-12-12.002zM12.563 22.893v-16.285l5.040 5.038c0.11 0.111 0.254 0.165 0.398 0.165s0.288-0.056 0.398-0.165c0.219-0.219 0.219-0.576 0-0.795l-6-5.998c0-0.002-0.002 0-0.003-0.002-0.101-0.101-0.239-0.162-0.392-0.163-0.003 0-0.005 0-0.007 0-0.152 0.001-0.29 0.063-0.39 0.162 0 0.001-0.002 0-0.003 0.001l-6 5.998c-0.219 0.219-0.219 0.577 0 0.795 0.219 0.222 0.574 0.221 0.795 0.002l5.040-5.038v16.284c-5.76-0.295-10.358-5.061-10.358-10.892 0-6.022 4.899-10.92 10.92-10.92s10.92 4.899 10.92 10.92c0 5.832-4.598 10.596-10.358 10.893z",
    fill: color
  }));
}